import Vue from 'vue'
import Vuex from 'vuex'
import axios from '../axios'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    searchKeyword: '',
    tempKeyword: '',
    parishList: [],
    selectedParish: null,
    parishExists: false,
    signupType: '',
    hasPSMA: false,
    psmaNumber: '',
    hasAPGB: false,
    wantsAPGB: false,
    personalDetails: {},
    councilDetails: {},
    additionalDetails: {},
    password: '',
    responseStatus: '',
    couponID: '',
    activatedCoupon: {},
  },
  mutations: {
    SET_SEARCH_KEYWORD(state, payload) {
      state.searchKeyword = payload.toLocaleLowerCase();
    },
    SET_PARISH_LIST(state, payload) {
      state.parishList = payload;
    },
    SET_SELECTED_PARISH(state, payload) {
      state.selectedParish = payload;
    },
    SET_PARISH_EXISTS(state, payload) {
      state.parishExists = payload;
    },
    SET_SIGNUP_TYPE(state, payload) {
      state.signupType = payload;
    },
    SET_HAS_PSMA(state, payload) {
      state.hasPSMA = payload;
    },
    SET_PSMA_NUMBER(state, payload) {
      state.psmaNumber = payload;
    },
    SET_HAS_APGB(state, payload) {
      state.hasAPGB = payload;
    },
    SET_WANTS_APGB(state, payload) {
      state.wantsAPGB = payload;
    },
    SET_PERSONAL_DETAILS(state, payload) {
      state.personalDetails = payload;
    },
    SET_COUNCIL_DETAILS(state, payload) {
      state.councilDetails = payload;
    },
    SET_ADDITIONAL_DETAILS(state, payload) {
      state.additionalDetails = payload;
    },
    SET_PASSWORD(state, payload) {
      state.password = payload;
    },
    SET_RESPONSE_STATUS(state, payload) {
      state.responseStatus = payload;
    },
    SET_COUPON_ID(state, payload) {
      state.couponID = payload;
    },
    SET_ACTIVE_COUPON(state, payload) {
      state.activatedCoupon = payload;
    },
  },
  actions: {
    CHECK_COUPON({commit, state}) {

      let couponID = state.couponID;

      return new Promise((resolve, reject) => {
        axios.post(process.env.VUE_APP_API_URL + `/coupon`,
          {
            coupon: couponID,
          },
          {
            withCredentials: true
          }
        ).then((res) => {
          if (res.data.id) {
            commit('SET_ACTIVE_COUPON', res.data);
          } else {
            commit('SET_ACTIVE_COUPON', null);
          }

          resolve(res);
        }).catch((err) => {
          reject(err);
        });
      });
    },
    FETCH({commit, state}) {
      return new Promise((resolve, reject) => {
        let keyword = state.searchKeyword;

        axios.post(process.env.VUE_APP_API_URL + `/list`, {
          keyword: keyword,
        }, {withCredentials: true}).then((res) => {
          console.log('SEARCHED, NEW LIST: ' + res.data.length);

          function sortNumber(a, b) {
            return a.sortValue - b.sortValue;
          }

          function sortTitles(a, b) {
            if (a.search_key < b.search_key) {
              return -1;
            }
            if (a.search_key > b.search_key) {
              return 1;
            }
            return 0;
          }

          let list = _.cloneDeep(res.data);

          list.sort(sortTitles);

          list.forEach((parish) => {
            let sortValue = parish.search_key.indexOf(keyword);
            if (sortValue === -1) {
              list.splice(list.indexOf(parish), 1);
            } else {
              parish.sortValue = sortValue;
            }
          });

          list.sort(sortNumber);

          console.dir(list);

          commit('SET_PARISH_LIST', list);
          resolve(res);
        }).catch((err) => {
          reject(err);
        });
      });
    },
    CLEAR_LIST({commit}) {
      return new Promise((resolve,) => {
        commit('SET_PARISH_LIST', []);
        resolve();
      });
    },
    async GET_PRICE({commit, state}) {
      let price = await axios.get(process.env.VUE_APP_API_URL + '/price', {
        params: {
          census_code: state.selectedParish.census_id
        }
      })

      //merge price into current selected parish
      let updatedSelectedParish = {
        ...state.selectedParish,
        ...{price: price.data.amount}
      }

      commit('SET_SELECTED_PARISH', updatedSelectedParish )

      return price
    },
    CHECK_IF_EXISTING({commit, state}) {
      return new Promise((resolve, reject) => {
        let parishToCheck = state.selectedParish;

        axios.post(process.env.VUE_APP_API_URL + `/check`, {
          census_id: parishToCheck.census_id,
        }, {withCredentials: true}).then((res) => {
          commit('SET_PARISH_EXISTS', res.data[0].exists);

          resolve(res);
        }).catch((err) => {
          reject(err);
        });
      });
    },
    CREATE_ACCOUNT({commit, state}) {
      return new Promise((resolve, reject) => {
        let needsPSMA = (state.hasPSMA ? 'psma' : 'false');
        let needsAPGB = ((state.wantsAPGB || state.hasAPGB) ? 'apgb' : 'false');
        let apgbSource;

        if (state.wantsAPGB) {
          apgbSource = 'registration-wants';
        } else if (state.hasAPGB) {
          apgbSource = 'registration-already-has';
        } else {
          apgbSource = '';
        }


        let parish = state.selectedParish;
        let userDetails = state.personalDetails;
        let councilDetails = state.councilDetails;
        let additionalDetails = state.additionalDetails;
        let additionalGroups = needsPSMA + ',' + needsAPGB;
        let type = state.signupType === 'SUBSCRIPTION' ? 'full' : 'trial';
        let coupon = (state.activatedCoupon && state.activatedCoupon.id) ? state.activatedCoupon.id : (type === 'full' ? 'TgVqgXvo' : '');
        let source = additionalDetails.hearAboutUs === 'Other' ? 'Other - ' + additionalDetails.hearAboutUsOther : additionalDetails.hearAboutUs;
        let email_discount = coupon && coupon.length > 0 ? state.activatedCoupon.percent_off : (type === 'full' ? 10 : 0);

        let params = {
          org_id: parish.census_id,
          org_name: parish.organisation_title,
          org_title: parish.organisation_title,
          org_district: parish.organisation_district,
          extent: parish.extent,
          epsg: 27700,
          main_contact_name: `${userDetails.forename} ${userDetails.surname}`,
          main_contact_email: councilDetails.email,
          main_contact_phone: councilDetails.phone,
          main_contact_position: userDetails.position,
          main_contact_permission: userDetails.confirmation,
          address_line1: councilDetails.address,
          address_line2: councilDetails.address2,
          address_city: councilDetails.town,
          address_county: councilDetails.district,
          address_postcode: councilDetails.postcode,
          subtotal: parish.price,
          stripe_price_id: parish.stripe_price_id,
          additional_groups: additionalGroups,
          terms: additionalDetails.termsAccepted,
          stripe: true,
          psma_number: state.psmaNumber,
          password: state.password,
          type: type,
          coupon: coupon,
          notif: {
            source: source,
            apgb: state.wantsAPGB || state.hasAPGB ? 'true' : 'false',
            psma: state.psmaNumber.length > 0,
            apgb_source: apgbSource,
            coupon: state.activatedCoupon,
            email_discount: email_discount,
          },
          mail_chimp: {
            email: councilDetails.email,
            f_name: userDetails.forename,
            l_name: userDetails.surname,
            title: userDetails.title,
            org: parish.organisation_title,
            census: parish.census_id,
            district: parish.organisation_district,
            newsletter: additionalDetails.emailConfirm,
            customer: true, //always true
            trial: type === 'trial',
          },
        };

        axios.post(process.env.VUE_APP_API_URL + `/registration/parishonline`,
          params, {withCredentials: true})
          .then((res) => {
            commit('SET_RESPONSE_STATUS', 'pass');
            resolve(res);
          }).catch((err) => {
          commit('SET_RESPONSE_STATUS', 'error');
          reject(err);
        });
      });
    },
    TEST({commit, state}) {
      return new Promise((resolve, reject) => {
        let needsPSMA = 'true';
        let needsAPGB = 'false';
        let additionalGroups = needsPSMA + ',' + needsAPGB;

        let params = {
          org_id: '99xx901',
          org_name: 'Org Name',
          org_title: 'Parish CP',
          org_district: 'Org District',
          extent: '404280,260300,408576,264334',
          epsg: 27700,
          main_contact_name: 'Sam Colbourne',
          main_contact_email: 'mirass.steam+notbramley2@gmail.com',
          main_contact_phone: 'test',
          main_contact_position: 'Position',
          main_contact_permission: 'test',
          address_line1: 'test',
          address_line2: 'test',
          address_city: 'test',
          address_county: 'test',
          address_postcode: 'test',
          subtotal: 30,
          additional_groups: 'psma,apgb',
          terms: true,
          stripe: true,
          psma_number: '100012345',
          password: 'Password123!',
          type: 'trial',
          coupon: '',
          notif: {
            source: 'Source',
            psma: 'true',
            apgb: 'true',
            apgb_source: 'registration-already-has'
          },
          mail_chimp: {
            email: 'mirass.steam+notbramley2@gmail.com',
            f_name: 'First Name',
            l_name: 'Last Name',
            title: 'Mr',
            org: 'Title',
            census: '003231',
            district: 'District',
            newsletter: true,
            customer: true, //always true
            trial: false,
          },
        };

        axios.post(process.env.VUE_APP_API_URL + `/registration/parishonline`,
          params, {withCredentials: true})
          .then((res) => {
            commit('SET_RESPONSE_STATUS', 'pass');
            resolve(res);
          }).catch((err) => {
          commit('SET_RESPONSE_STATUS', 'error');
          reject(err);
        });
      });
    },
  },
  getters: {
    GET_SEARCH_KEYWORD(state) {
      return state.searchKeyword;
    },
    GET_PARISH_LIST(state) {
      return state.parishList;
    },
    GET_SELECTED_PARISH(state) {
      return state.selectedParish;
    },
    GET_PARISH_EXISTS(state) {
      return state.parishExists;
    },
    GET_SIGNUP_TYPE(state) {
      return state.signupType;
    },
    GET_PSMA_NUMBER(state) {
      return state.psmaNumber;
    },
    GET_HAS_APGB(state) {
      return state.hasAPGB;
    },
    GET_WANTS_APGB(state) {
      return state.wantsAPGB;
    },
    GET_PERSONAL_DETAILS(state) {
      return state.personalDetails;
    },
    GET_COUNCIL_DETAILS(state) {
      return state.councilDetails;
    },
    GET_ADDITIONAL_DETAILS(state) {
      return state.additionalDetails;
    },
    GET_RESPONSE_STATUS(state) {
      return state.responseStatus;
    },
    GET_ACTIVE_COUPON(state) {
      return state.activatedCoupon;
    },
    GET_ALL_DATA(state) {
      return {
        parish: state.selectedParish,
        personal: state.personalDetails,
        council: state.councilDetails,
        additionalDetails: state.additionalDetails,
        apgb: {
          has: state.hasAPGB,
          wants: state.wantsAPGB,
        },
        psma: {
          has: state.hasPSMA,
          number: state.psmaNumber,
        },
        type: state.signupType,
        coupon: state.activatedCoupon,
      };
    }
  },
});
